import React from 'react'
import OtpVerification from '../../components/form/SignUp/OtpVerification'
import CustomNavbar from './PublicNavbar'

export default function OtpPage() {
    return (
        <>
            <CustomNavbar />
            <div className="signup-page mt-4">
                <div className="signup-form-container2">
                    <OtpVerification />
                </div>
            </div>
        </>
    )
}
